<template>
  <div class="hotelsMap" ref="pageContainer" :style="`height: ${pageMaxHeight}px;`">
    <div class="hotelsMap__sidebar" ref="hotelsMap__sidebar">
      <div v-if="isDesktop && isLoadingList" class="loadingContainer">
        <div class="loadingContainer__frame">
          <loadingBlock>
            <span class="text-sm text-white">{{ $t('loading') }}...</span>
          </loadingBlock>
        </div>
      </div>
      <!-- <div class="bg-white border-b-1 border-grey-lighter p-8">
        <label class="input input-icon w-full searchBox__input">
          <i class="search-icon owl-search"></i>
          <input class="flex-auto"
            ref="searchInput"
            style="line-height: 1;"
            type="text"
            :placeholder="$t('searchLocation')">
        </label>
      </div> -->
      <div class="mapList" :style="`height: ${pageMaxHeight}px;`">
        <searchModal
          v-if="showFilter && isDesktop"
          class="h-full w-full"
          ref="searchModalRef"
          :hotel-quantity="hotelList.data.groupByData.hotel"
          :tour-quantity="hotelList.data.groupByData.experience"
          :facility-data="hotelList.data.facilityData"
          :has-stock-data="hotelList.data.inventoryFilterData"
          :hotel-type-data="hotelList.data.hotelTypeData"
          :price-data="hotelList.data.priceData"
          :quarantine-data="hotelList.data.quarantineHotelFilterData"
          :star-data="hotelList.data.starData"
          :tag-data="hotelList.data.tagData"
          @close="showFilter = false"
          @submit="searchWithCondition"
        />
        <div v-else class="h-full w-full flex flex-col overflow-hidden">
          <div v-if="!isLoadingList && hotelList.data.topData" @click="onClickInfoCard(hotelList.data.topData.data)" class="flex-shrink-0 pt-8 px-8">
            <hotelCard
              :hotel-data="hotelList.data.topData.data"
              :ref="`${hotelList.data.topData.type}_${mapCardUuid(hotelList.data.topData.data)}`"
              :star-filter="hotelList.data.starData"
              :is-active="selectedHotel && hotelList.data.topData.data.hotelUUID === selectedHotel.uuid"
            />
          </div>
          <div class="sortBar flex-shrink-0 bg-grey-lightest p-4 m-8 flex items-center justify-between" style="border-radius: 20px;">
            <div class="bg-white border-1 border-grey-light inline-flex" style="border-radius: 20px;">
              <div class="font-semibold py-8 px-24 pointer-events-none text-sm">{{ $t('sortBy') }} :</div>
              <div class="border-l border-grey-light cursor-pointer flex items-center px-24 font-semibold text-grey-darkest text-sm" :class="sortRule === 'default' ? 'bg-blue-light text-white' : ''" @click="onSortChange('default')">
                {{ $t('sortRule.default') }}
              </div>
              <el-dropdown trigger="click" @command="onSortChange" class="flex-grow flex items-center border-l border-grey-light">
                <div class="font-semibold text-sm text-grey-darkest block p-8" :class="sortRule !== 'default' ? 'bg-blue-light text-white' : ''">
                  <span v-if="sortRule === 'default'" class="px-8">{{ $t(`sortRule.price.${sortRule.toLowerCase()}`) }}</span>
                  <span v-else class="px-8">{{ $t(`sortRule.price.${sortRule.toLowerCase()}`) }}</span>
                  <i class="text-grey owl-direction-down- owl-direction-down" :class="sortRule !== 'default' ? 'text-white' : ''" />
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="ASC" :class="sortRule === 'ASC' ? 'text-blue' : ''">{{ $t('sortRule.price.asc') }}</el-dropdown-item>
                  <el-dropdown-item command="DESC" :class="sortRule === 'DESC' ? 'text-blue' : ''">{{ $t('sortRule.price.desc') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <button @click="openFilter" class="btn bg-white text-sm py-4 px-16 border border-grey-light" :class="{ 'active': conditionCount > 0 }" :disabled="isLoadingList" style="border-radius: 20px;">
              <i class="owl-adjust text-lg"></i>
              <span>{{ $t('filter') }}</span>
              <span v-show="conditionCount > 0"> ({{ conditionCount }})</span>
            </button>
          </div>
          <div class="flex-1 overflow-y-auto" v-dragscroll ref="searchListRef">
            <div class="pb-8 w-full">
              <div v-if="!productList.length && !isLoadingList" class="emptyStatus">
                <div class="text-center">
                  <img height="60" width="60" src="@/assets/images/icon-empty-status.svg" class="mb-16" alt="no result" />
                  <div class="text-center">
                    <h3 class="text-grey-darkest font-bold">{{ $t('mapCard.noResult') }}</h3>
                    <div>{{ $t('mapCard.pleaseRetry') }}</div>
                  </div>
                </div>
              </div>
              <div v-else v-for="(hotel, index) in productList" :key="index" @click="onClickInfoCard(hotel.data)" class="mb-16 px-8 w-full">
                <hotelCard
                  v-if="hotel.type === 'hotel'"
                  :hotel-data="hotel.data"
                  :ref="`${hotel.type}_${mapCardUuid(hotel.data)}`"
                  :star-filter="hotelList.data.starData"
                  :is-active="selectedHotel && hotel.data.hotelUUID === selectedHotel.uuid"
                />
                <tourCard
                  v-else-if="hotel.type === 'experience'"
                  :ref="`${hotel.type}_${mapCardUuid(hotel.data)}`"
                  :tour-data="hotel.data"
                  :is-active="selectedHotel && hotel.data.id === selectedHotel.uuid"
                />
              </div>
            </div>
            <div ref="searchListEndRef" style="margin-top: -1px;"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="gmap">
      <div class="gmap__option-group">
        <div  @click="gotoList()" class="bg-white rounded-full shadow-lg cursor-pointer" style="padding: 10px">
          <i class="el-icon-close text-xl" />
        </div>
        <!-- <button @click="openFilter" class="btn btn-solid mr-8" :class="{ 'active': conditionCount > 0 }" :disabled="isLoadingList">
          <i class="owl-adjust text-lg"></i>
          <span>{{ $t('filter') }}</span>
        </button> -->
        <!-- <button @click="searchForArea()" class="btn btn-solid active" :disabled="isLoadingList" v-show="isDesktop && showSearchAreaButton">
          <i class="owl-search text-lg"></i><span>{{ $t('mapCard.searchArea') }}</span>
        </button> -->
      </div>
      <div class="gmap__option-group-left">
        <button @click="openFilter" class="btn bg-white text-sm py-4 px-16 border border-grey-light" :class="{ 'active': conditionCount > 0 }" :disabled="isLoadingList">
          <i class="owl-adjust text-sm"></i>
          <span>{{ $t('filter') }}</span>
          <span v-show="conditionCount > 0"> ({{ conditionCount }})</span>
        </button>
      </div>
      <GmapMap
        class="h-full"
        ref="mapRef"
        :center="mapCenter"
        :options="gmapOptions"
        :zoom="mapZoom"
        @idle="sync"
        @click="onClickMap"
        @center_changed="onChangingCenter"
        @zoom_changed="onChangingZoom"
        @bounds_changed="onChangingBounds"
        :tilt="45"
        v-loading="isLoadingMap"
      >
        <GmapCustomMarker
          v-if="$route.query.search && isArea"
          class="GmapCustomMarker"
          :marker="mapCenterNow"
          :z-index="selectedHotel.uuid === 'searchCenter' ? 4 : 3"
        >
          <div class="searchKeywordMarker" @click.stop="clickSearchMarker" @touchstart.stop>
            <i class="owl-camera-slr"> </i>{{ $route.query.search }}
          </div>
          <!-- <div class="mapCenterDot"></div> -->
        </GmapCustomMarker>
        <!-- <GmapCircle
          key="searchRangeCircle"
          :center="searchResultCenter"
          :radius="radius"
          :visible="true"
          :options="{
            strokeColor: owlsight.colors.blue,
            strokeOpacity: 0.2,
            strokeWeight: 0,
            fillColor: owlsight.colors['blue-light'],
            fillOpacity: 0.15
          }" /> -->
        <template v-if="markerList.length > 0">
          <GmapCustomMarker
            v-for="(hotel, index) in markerList"
            class="GmapCustomMarker"
            :marker="{lat: Number(hotel.data.latitude), lng: Number(hotel.data.longitude)}"
            :key="mapCardUuid(hotel.data)"
            :z-index="selectedHotel.uuid === mapCardUuid(hotel.data) ? 5 : (hotel.data.inStock ? 1 : 0)">
            <div
              class="customPriceMarker flex items-center"
              :class="{'activate': selectedHotel.uuid === mapCardUuid(hotel.data),
                'sold-out': !hotel.data.inStock,
                'pattern-blue-light': hotel.data.type === 'hotel',
                'pattern-orange-dark': hotel.data.type === 'experience'}"
              @click.stop="clickMark(hotel.data, index)"
              @touchstart.stop
            >
              <!-- [2022-04-21] 隱藏 marker icon -->
              <!-- <div class="inline-block mr-4 w-6">
                <img v-if="hotel.data.type === 'experience'" src="@/assets/images/icon-experiences.svg" class="w-full" />
                <img v-else src="@/assets/images/icon-hotel.svg" class="w-full" />
              </div> -->
              <span :class="!hotel.data.inStock ? 'text-xs' : ''">
                {{ labelText(hotel.data) }}
              </span>
            </div>
            <mapCard
              v-if="isDesktop"
              class="infoWindow"
              @click.native.stop
              @dblclick.native.stop
              @close-handler="clickMark(hotel.data, index)"
              :hotel="hotel.data"
            />
          </GmapCustomMarker>
        </template>
        <!-- <gmap-cluster :maxZoom="11" :minimumClusterSize="5" :gridSize="200" enableRetinaIcons :styles="clusterStyles" zoomOnClick>
          <template v-for="(hotel, index) in productList">
            <GmapCustomMarker class="GmapCustomMarker" :marker="{lat: Number(hotel.data.latitude), lng: Number(hotel.data.longitude)}" :key="index" :z-index="selectedHotel.uuid === hotel.hotelUUID ? 1 : 0">
              <div
                class="customPriceMarker"
                :class="{'activate': selectedHotel.uuid === hotel.hotelUUID}"
                @click="clickMark(hotel)"
              >
                <span>{{ labelText(hotel) }}</span>
              </div>
              <mapCard
                class="infoWindow"
                @click.stop
                :hotel="hotel"
              />
            </GmapCustomMarker>
          </template>
        </gmap-cluster> -->
      </GmapMap>
    </div>
    <div v-if="showFilter && !isDesktop" class="searchOverlay__mobile">
      <searchModal
        class="h-full w-full"
        ref="searchModalRef"
        :hotel-quantity="hotelList.data.groupByData.hotel"
        :tour-quantity="hotelList.data.groupByData.experience"
        :facility-data="hotelList.data.facilityData"
        :has-stock-data="hotelList.data.inventoryFilterData"
        :hotel-type-data="hotelList.data.hotelTypeData"
        :price-data="hotelList.data.priceData"
        :quarantine-data="hotelList.data.quarantineHotelFilterData"
        :star-data="hotelList.data.starData"
        :tag-data="hotelList.data.tagData"
        @close="showFilter = false"
        @submit="searchWithCondition"
      />
    </div>
    <div v-show="!isDesktop && isLoadingList" class="loadingContainer__mobile">
      <div class="loadingContainer__frame">
        <loadingBlock>
          <span class="text-sm text-white">{{ $t('loading') }}...</span>
        </loadingBlock>
      </div>
    </div>
    <div class="hotelsMap__mobile">
      <div v-show="!isLoadingList" class="gmap__location-group align-right">
        <button @click="returnToMapCenter">
          <i class="owl-location" />
        </button>
      </div>
      <!-- <div v-show="!isLoadingList" class="gmap__location-group align-center">
        <button class="btn btn-solid btn-blue-light" @click="searchForArea()" :disabled="isLoadingList" v-show="!isDesktop && showSearchAreaButton">
          <i class="owl-search text-lg"></i><span>{{ $t('mapCard.searchArea') }}</span>
        </button>
      </div> -->
      <div class="mapList" v-dragscroll>
        <div v-show="!productList.length && !hotelList.data.topData && !isLoadingList" class="emptyStatus__mobile">
          <div class="flex items-center">
            <img height="40" width="40" src="@/assets/images/icon-empty-status.svg" alt="no result" />
          </div>
          <div class="ml-16">
            <h3 class="text-grey-darkest font-bold">{{ $t('mapCard.noResult') }}</h3>
            <div class="font-medium text-xs">{{ $t('mapCard.pleaseRetry') }}</div>
          </div>
        </div>
        <hotelCard
          v-if="hotelList.data.topData && hotelList.data.topData.data.hotelUUID === selectedHotel.uuid"
          :is-active="hotelList.data.topData.data.hotelUUID === selectedHotel.uuid"
          :hotel-data="hotelList.data.topData.data"
          :star-filter="hotelList.data.starData"
          @click.native="onClickInfoCard(hotelList.data.topData.data)"
          class="mx-8"
          style="width: calc(100% - 16px);"
          mode="clickable-container"
        />
        <template v-for="(hotel, index) in productList">
          <hotelCard
            v-if="hotel.type === 'hotel' && hotel.data.hotelUUID === selectedHotel.uuid"
            :key="index"
            :hotel-data="hotel.data"
            :is-active="hotel.data.hotelUUID === selectedHotel.uuid"
            :star-filter="hotelList.data.starData"
            @click.native="onClickInfoCard(hotel.data)"
            class="mx-8"
            style="width: calc(100% - 16px);"
            mode="clickable-container"
          />
          <!-- [2022-04-06] 現階段不需顯示體驗卡片 -->
          <!-- <tourCard
            v-else-if="hotel.type === 'experience' && hotel.data.id === selectedHotel.uuid"
            :key="index"
            :is-active="hotel.data.id === selectedHotel.uuid"
            :tour-data="hotel.data"
            @click.native="onClickInfoCard(hotel.data)"
            class="mx-8"
          /> -->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import loadingBlock from '@/components/loadingBlock'
import mapCard from '@/views/HotelsMap/components/mapCard.vue'
import hotelCard from '@/views/HotelsMap/components/hotelCard.vue'
import tourCard from '@/views/HotelsMap/components/tourCard.vue'
import searchModal from '@/views/HotelsMap/components/searchModal'
import owlsight from 'owlsight/src/tailwind.js'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import clusterImage from '@/assets/transparent.png'
import { countConditions, countConditionsFromQuery } from '@/utils/filterHash.js'

const SEARCH_CLASS_ID = 'searchId'
const SEARCH_CLASS_CIRCLE = 'circle'
const SEARCH_CLASS_RECTANGLE = 'rectangle'

const DEFAULT_ZOOM_LEVEL = 13

const DEFAULT_RECT_COORDINATE = {
  topLeft: {
    latitude: 0,
    longitude: 0
  },
  bottomRight: {
    latitude: 0,
    longitude: 0
  }
}

export default {
  name: 'hotelsMap',
  components: {
    loadingBlock,
    mapCard,
    hotelCard,
    tourCard,
    searchModal,
    GmapCustomMarker
  },
  metaInfo () {
    return {
      title: this.$t('hotelsMap'),
      meta: [
        {
          'property': 'og:title',
          'content': this.$t('hotelsMap'),
          'vmid': 'og:title'
        }
      ]
    }
  },
  data () {
    return {
      SEARCH_CLASS_ID,
      SEARCH_CLASS_CIRCLE,
      SEARCH_CLASS_RECTANGLE,
      fetchListQuery: {
        page: 1,
        pageSize: 12,
        mobilePageSize: 50
      },
      isLoadingMap: false,
      radius: 3000,
      clusterImageUrl: clusterImage,
      conditionCount: 0,
      isLoadingList: false,
      observer: null,
      onChangeDate: false,
      productList: [],
      resize: null,
      navHeight: 0,
      owlsight: owlsight,
      searchClass: SEARCH_CLASS_ID,
      sortRule: 'default',
      selectedHotel: {
        uuid: ''
      },
      showFilter: false,
      showSearchAreaButton: false,
      mapZoom: DEFAULT_ZOOM_LEVEL,
      mapMarkerAnimation: 4,
      searchResultAreaNow: _.cloneDeep(DEFAULT_RECT_COORDINATE),
      searchResultArea: _.cloneDeep(DEFAULT_RECT_COORDINATE),
      searchResultCenter: {
        lat: 0,
        lng: 0
      },
      mapCenterNow: {
        lat: 0,
        lng: 0
      },
      mapCenter: {
        lat: 0,
        lng: 0
      },
      infoWindow: {},
      infoWindowOpen: false,
      gmapOptions: {
        tilt: 0,
        heading: 0,
        clickableIcons: false,
        gestureHandling: 'greedy',
        zoomControl: true,
        minZoom: 10,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        tiltControl: false,
        mapId: 'd4991e8d20014286a372c55f'
      },
      isArea: false
    }
  },
  computed: {
    ...mapGetters({
      currencySign: 'user/currencySign',
      selectedCurrency: 'user/selectedCurrency',
      windowHeight: 'windowHeight',
      isDesktop: 'isDesktop',
      isLoadingHotelsMap: 'hotels/isLoadingHotelsMap',
      hotelList: 'hotels/hotels',
      'search/dateRange': 'search/dateRange'
    }),
    clusterStyles: function () {
      return [
        {
          width: 40,
          height: 40,
          url: this.clusterImageUrl,
          textColor: '#fff',
          textSize: 20
        },
        {
          width: 41,
          height: 41,
          url: this.clusterImageUrl,
          textColor: '#fff',
          textSize: 24
        },
        {
          width: 42,
          height: 42,
          url: this.clusterImageUrl,
          textColor: '#fff',
          textSize: 26
        }
      ]
    },
    markerList: function () {
      if (this.hotelList.data.topData) {
        return [this.hotelList.data.topData].concat(this.productList)
      }
      return this.productList
    },
    pageMaxHeight: function () {
      return this.windowHeight - this.navHeight
    },
    dateRange: function () {
      const startDate = this['search/dateRange'].start ? this.$dayjs(this['search/dateRange'].start).format('YYYY-MM-DD') : this.$dayjs().add(7, 'day').format('YYYY-MM-DD')
      return {
        start: startDate,
        end: this['search/dateRange'].end ? this.$dayjs(this['search/dateRange'].end).format('YYYY-MM-DD') : this.$dayjs(startDate).add(1, 'day').format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    ...mapActions([
      'hotels/fetchHotelsMapByLocation',
      'hotels/fetchHotels',
      'search/updateDateRange',
      'search/getItemByAutoCompleteId'
    ]),
    panToCenter: function ({ lat, lng }) {
      this.mapCenter.lat = Number(lat)
      this.mapCenter.lng = Number(lng)
    },
    mapCardUuid: function (hotel) {
      switch (hotel.type) {
        case 'experience':
          return hotel.id
        case 'hotel':
          return hotel.hotelUUID
      }
      return null
    },
    addFavoriteHandler: function (hotel) {
      this['user/addFavorite'](hotel.hotelUUID)
        .then(res => {
          if (res) {
            hotel.isFavorite = true
            this.$message({
              message: this.$t('addItemToFavorite', [hotel.hotelNameLocal]),
              type: 'success'
            })
          }
        })
    },
    removeFavoriteHandler: function (hotel) {
      this['user/removeFavorite'](hotel.hotelUUID)
        .then(res => {
          if (res) {
            hotel.isFavorite = false
            this.$message({
              message: this.$t('removeItemFromFavorite', [hotel.hotelNameLocal]),
              type: 'warning'
            })
          }
        })
    },
    gotoList: function () {
      const query = _.pick(this.$route.query, ['searchId', 'search', 'start', 'end', 'room', 'adult', 'child', 'ages', 'externalId'])
      this.$router.push({ name: 'HotelsList', query })
    },
    labelText: function (hotel) {
      if (!hotel.inStock) {
        return this.$t('soldOut')
      }
      if (Number(hotel.price) > 0) {
        return `${this.$options.filters.currencySign()} ${this.$options.filters.currencyConvert(hotel.price, { inputCurrency: hotel.currency, listInteger: true })}`
      }
      return this.$t('mapCard.priceBaseOnConditions')
    },
    observeLoadMore: function () {
      const callback = (entries, observer) => {
        const pageSize = this.isDesktop ? this.fetchListQuery.pageSize : this.fetchListQuery.mobilePageSize
        const isLastPage = (pageSize * this.fetchListQuery.page) >= this.hotelList.data.pagination?.total
        if (entries[0].isIntersecting && !this.isLoadingList && !isLastPage) {
          this.fetchListQuery.page++
          this.fetchHotelList({ resetPage: false })
        }
      }
      const listEnd = this.$refs.searchListEndRef

      if (!this.observer) {
        this.observer = new IntersectionObserver(callback, { root: this.$refs.searchListRef })
        this.observer.observe(listEnd)
      }
    },
    onClickMap: function () {
      this.unselectCard()
    },
    onChangingCenter: function (latLng) {
      if (!this.showSearchAreaButton) {
        this.showSearchAreaButton = true
      }
      this._pendingCenter = { lat: latLng.lat(), lng: latLng.lng() }
    },
    onSortChange: function (event) {
      this.sortRule = event
      this.fetchHotelList()
    },
    openFilter: function () {
      this.showFilter = true
    },
    sync: function () {
      if (this._pendingCenter) {
        this.mapCenter = this._pendingCenter
        this._pendingCenter = null
      }
      if (this._pendingBounds) {
        const bounds = JSON.parse(JSON.stringify(this._pendingBounds))
        this.searchResultAreaNow = {
          topLeft: {
            latitude: bounds.north,
            longitude: bounds.west
          },
          bottomRight: {
            latitude: bounds.south,
            longitude: bounds.east
          }
        }
        this._pendingBounds = null
      }
      if (this.showSearchAreaButton) {
        clearTimeout(this._syncSearchTimer)
        this._syncSearchTimer = setTimeout(() => {
          this.searchForArea()
        }, 1000)
      }
    },
    onChangingZoom: function (zoom) {
      this.mapZoom = zoom
      if (!this.showSearchAreaButton) {
        this.showSearchAreaButton = true
      }
    },
    onChangingBounds: function (event) {
      if (!event) {
        return false
      }
      this._pendingBounds = event
    },
    unselectCard: function () {
      this.selectedHotel = { uuid: '' }
    },
    clickSearchMarker: function () {
      if (this.selectedHotel.uuid === 'searchCenter') {
        this.unselectCard()
      } else {
        this.selectedHotel.uuid = 'searchCenter'
      }
    },
    clickMark: function (hotel, slideIndex) {
      const uuid = this.mapCardUuid(hotel)
      if (this.selectedHotel.uuid === uuid) {
        this.unselectCard()
      } else {
        this.selectedHotel.uuid = uuid
        this.panToCenter({ lat: Number(hotel.latitude), lng: Number(hotel.longitude) })
        if (slideIndex >= 0 && this.$refs.mapSwiper) {
          this.$refs.mapSwiper.swiper.slideTo(slideIndex, 0)
        }
        this.$nextTick(() => {
          const hotelCardRef = this.$refs[`${hotel.type}_${uuid}`]

          if (_.isArray(hotelCardRef)) {
            hotelCardRef[0].$el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
          } else if (hotelCardRef) {
            hotelCardRef.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
          }
        })
      }
    },
    onClickInfoCard: function (hotel) {
      if (this.selectedHotel.uuid !== this.mapCardUuid(hotel)) {
        this.selectedHotel.uuid = this.mapCardUuid(hotel)
        this.panToCenter({ lat: Number(hotel.latitude), lng: Number(hotel.longitude) })
      }
    },
    returnToMapCenter: function () {
      this.panToCenter({ lat: this.mapCenterNow.lat, lng: this.mapCenterNow.lng })
    },
    setNavHeight: function () {
      this.navHeight = this.$refs.pageContainer ? this.$refs.pageContainer.offsetTop : 0
    },
    clearSearchConditions: function () {
      let query = _.omit(this.$route.query, ['minPrice', 'maxPrice'])

      if (this.$route.query.filter?.length > 0) {
        query = _.omit(query, ['filter'])
      }
      // [2021-05-26] 隱藏體驗類型商品，故 searchType 應固定為 hotel
      // if (this.$route.query.searchType === 'hotel' || this.$route.query.searchType === 'experience') {
      //   delete query.searchType
      // }
      if (this.$refs.searchModalRef) {
        this.$refs.searchModalRef.clearHandler()
      }
      this.conditionCount = 0
      this.$router.replace({ query }).catch(() => {})
    },
    searchForArea: function () {
      const tmpCount = this.conditionCount

      this.searchResultCenter.lat = this.mapCenter.lat
      this.searchResultCenter.lng = this.mapCenter.lng
      this.searchResultArea = _.cloneDeep(this.searchResultAreaNow)
      this.searchClass = SEARCH_CLASS_RECTANGLE
      this.clearSearchConditions()
      if (tmpCount === 0) {
        this.fetchHotelList()
      }
    },
    searchWithCondition: function (searchConditions) {
      const params = Object.assign({ filter: [] }, _.pick(this.$route.query, ['search', 'searchId', 'start', 'end', 'room', 'adult', 'child', 'ages']))

      _.forEach(searchConditions.filterIds, (value, key) => {
        if (value) {
          params.filter.push(key)
        }
      })
      if (searchConditions.minPrice) {
        params.minPrice = searchConditions.minPrice
      }
      if (searchConditions.maxPrice) {
        params.maxPrice = searchConditions.maxPrice
      }

      // TODO: 待 API 改為可搜尋多個 searchType 後，再更改下面這段邏輯
      if (searchConditions.searchType.experience ^ searchConditions.searchType.hotel) {
        params.searchType = searchConditions.searchType.experience ? 'experience' : 'hotel'
      }
      this.conditionCount = countConditions(searchConditions)
      this.$router.replace({ name: 'HotelsMap', query: { ...params, t: new Date().getTime() } })
    },
    fetchHotelList: function (extraOptions) {
      const options = {
        searchBy: this.searchClass || SEARCH_CLASS_RECTANGLE,
        extraParams: undefined,
        resetPage: true,
        ...extraOptions
      }

      this.showFilter = false
      this.isLoadingList = true
      this.showSearchAreaButton = false
      return new Promise((resolve, reject) => {
        let params = {
          searchType: 'hotel', // [2021-05-26] 隱藏體驗類型商品
          adult: this.$route.query.adult || 2,
          child: this.$route.query.child || 0,
          currency: this.selectedCurrency.toLowerCase(),
          radius: 20, // km
          start: this.dateRange.start,
          end: this.dateRange.end,
          minPrice: this.$route.query.minPrice || undefined,
          maxPrice: this.$route.query.maxPrice || undefined,
          pageSize: this.isDesktop ? this.fetchListQuery.pageSize : this.fetchListQuery.mobilePageSize
        }

        switch (options.searchBy) {
          case SEARCH_CLASS_ID:
            params = {
              ...params,
              rangeType: 'admini',
              searchId: this.$route.query.searchId ? this.$route.query.searchId : 1
            }
            break
          case SEARCH_CLASS_RECTANGLE:
            params = {
              ...params,
              rangeType: 'rectangle',
              topLeft: Object.assign({}, this.searchResultArea.topLeft),
              bottomRight: Object.assign({}, this.searchResultArea.bottomRight)
            }
            break
          default:
            params = {
              ...params,
              rangeType: 'circle',
              radius: this.radius / 1000,
              latitude: this.searchResultCenter.lat,
              longitude: this.searchResultCenter.lng
            }
            delete params.searchId
        }

        if (this.$route.query.searchType === 'hotel' || this.$route.query.searchType === 'experience') {
          params.searchType = this.$route.query.searchType
        }

        if (this.$route.query.filter) {
          if (Array.isArray(this.$route.query.filter)) {
            params.filter = this.$route.query.filter
          } else if (typeof this.$route.query.filter === 'string') {
            params.filter = [this.$route.query.filter]
          }
        }

        if (options.extraParams) {
          params = { ...params, ...options.extraParams }
        }

        if (this.sortRule !== 'default') {
          params = { ...params, orderBy: 'price', sortBy: this.sortRule }
        }

        if (options.resetPage) {
          this.fetchListQuery.page = 1
          this.productList = []
        }
        params.page = this.fetchListQuery.page
        this['hotels/fetchHotels'](params)
          .then(res => {
            if (res && res.status !== 200) return reject(res.msg)
            this.conditionCount = countConditionsFromQuery(this.$route.query)
            this.productList = this.productList.concat(this.hotelList.data.searchData)
            this.unselectCard()
            resolve(res)
          }).catch(err => {
            reject(err)
          }).finally(() => {
            this.isLoadingList = false
          })
      })
    }
  },
  created () {
    this.resize = _.debounce(() => {
      this.setNavHeight()
    }, 300)
    this.$nextTick(function () {
      this.setNavHeight()
    })
  },
  mounted () {
    window.addEventListener('resize', this.resize)
    this.observeLoadMore()
    this.$refs.mapRef.options.zoomControl = this.isDesktop
    if (this.$route.query?.start) {
      this.dateRange.start = this.$route.query.start
    }
    if (this.$route.query?.end) {
      this.dateRange.end = this.$route.query.end
    }
    this.fetchHotelList()
      .then(res => {
        if (res.data.topData) {
          this.onClickInfoCard(res.data.topData.data)
        }
        this['search/getItemByAutoCompleteId'](this.$route.query.searchId).then(res => {
          // if (!this.hotelList.data.topData) {
          //   this.mapCenterNow.lat = Number(this.hotelList.data.searchData[0].data.latitude)
          //   this.mapCenterNow.lng = Number(this.hotelList.data.searchData[0].data.longitude)
          //   this.mapCenter.lat = this.mapCenterNow.lat
          //   this.mapCenter.lng = this.mapCenterNow.lng
          // } else {
          this.mapCenterNow.lat = Number(res.latitude)
          this.mapCenterNow.lng = Number(res.longitude)
          this.mapCenter.lat = this.mapCenterNow.lat
          this.mapCenter.lng = this.mapCenterNow.lng
          // }
          this.searchResultCenter.lat = Number(res.latitude)
          this.searchResultCenter.lng = Number(res.longitude)
          this.searchResultArea = _.cloneDeep(this.searchResultAreaNow)
          this.isArea = res.type === 'area'
        })
      })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  },
  watch: {
    isDesktop: function (val) {
      this.$refs.mapRef.options.zoomControl = val
    },
    selectedCurrency () {
      this.fetchHotelList()
    },
    showFilter: function (val) {
      if (val) {
        this.observer.unobserve(this.$refs.searchListEndRef)
        this.observer = null
      } else {
        this.$nextTick(() => {
          this.observeLoadMore()
        })
      }
    },
    '$route.query': {
      handler (val, oldVal) {
        const triggerSearchBar = Boolean(val.trigger)

        // 搜尋房源時，篩選條件重設
        if (val.searchId !== oldVal.searchId || val.start !== oldVal.start || val.end !== oldVal.end ||
            val.adult !== oldVal.adult || val.child !== oldVal.child || triggerSearchBar) {
          this.clearSearchConditions()
          this.mapZoom = DEFAULT_ZOOM_LEVEL
          this.searchClass = SEARCH_CLASS_ID
          this.isLoadingMap = true
          this.fetchHotelList()
            .then(res => {
              if (res.data.topData) {
                this.onClickInfoCard(res.data.topData.data)
              }
              this['search/getItemByAutoCompleteId'](this.$route.query.searchId)
                .then(res => {
                  this.mapCenterNow.lat = Number(res.latitude)
                  this.mapCenterNow.lng = Number(res.longitude)
                  this.mapCenter.lat = this.mapCenterNow.lat
                  this.mapCenter.lng = this.mapCenterNow.lng
                  this.searchResultCenter.lat = Number(res.latitude)
                  this.searchResultCenter.lng = Number(res.longitude)
                  this.searchResultArea = _.cloneDeep(this.searchResultAreaNow)
                  this.isArea = res.type === 'area'
                })
            })
            .finally(() => {
              this.isLoadingMap = false
            })
        } else {
          this.fetchHotelList()
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="sass" scoped>
.hotelsMap
  @apply relative h-full
  @apply flex flex-col
  @screen lg
    @apply flex flex-row
    @apply flex-auto
    @apply mb-48
    @screen md
      @apply mb-0
  .gmap
    flex: 1 1 auto
    width: 100%
    height: 100%
    &__option-group
      @apply absolute pt-16 px-16 text-sm
      z-index: 1
      right: 0
      button
        @apply bg-grey-darkest rounded-full
        opacity: .75
        margin-bottom: 8px
        &.active
          @apply bg-blue-light text-white
          opacity: 0.9
    &__option-group-left
      @apply absolute pt-16 px-16 text-sm
      z-index: 1
      left: 0
      @screen lg
        @apply hidden
      button
        @apply bg-white rounded-full border border-grey-light
        opacity: .75
        &.active
          @apply bg-blue-light text-white
          opacity: 0.9
    &__location-group
      @screen lg
        top: 0
      @apply absolute flex justify-center
      height: 40px
      top: -48px
      z-index: 1
      i
        margin: 0
        &::before
          margin: 0 !important
      button
        @apply outline-none
      &.align-center
        @apply absolute items-end
        left: 50%
        transform: translateX(-50%)
        button
          @apply py-4 text-sm
          border-radius: 24px
      &.align-right
        @apply absolute bg-white border-1 border-grey-lightest rounded-full shadow text-xl
        right: 8px
        width: 40px
  .emptyStatus
    @apply flex justify-center py-40
    &__mobile
      @apply bg-white flex w-full mx-16 my-8 p-16 rounded-sm
  &__sidebar
    min-width: 580px
    // max-width: 50vw
    max-width: 580px
    @apply hidden shadow-lg relative
    @screen lg
      @apply block
    .mapList
      @apply relative bg-white flex flex-col items-center justify-start
      overflow-x: hidden
    .sortBar
      .active
          @apply bg-blue-light text-white
          opacity: 0.9
  &__mobile
    @screen lg
      @apply mb-8
      height: 40px
      right: 2px
      bottom: 120px
      width: 40px
    @apply absolute w-full
    bottom: 16px
    .mapList
      @screen lg
        @apply hidden
      @apply w-full flex flex-row float-right items-end
      overflow-y: hidden
    .slide
      box-sizing: border-box
      width: 80vw
      max-width: 350px
      &:first-child
        margin-left: 8px
      &:last-child
        border-right: 8px solid transparent
.searchOverlay
  &__mobile
    @apply absolute pin-b pin-x z-100
    height: calc(100% + 83px)
    @screen lg
      display: none
.loadingContainer
  @apply absolute flex items-center justify-center pin
  background-color: rgba(255, 255, 255, .5)
  z-index: 1
  &__mobile
    @apply absolute flex items-center justify-center pin
    z-index: 1
  &__frame
    @apply p-16 rounded-lg
    background-color: rgba(20, 20, 20, .65)
    width: 30%
    min-width: 160px
.GmapCustomMarker
  @apply relative cursor-pointer
  .searchKeywordMarker
    @apply absolute bg-grey-darkest text-white font-bold text-sm rounded-full shadow-lg
    padding: 6px 7px
    white-space: nowrap
    left: 50%
    // bottom: 20px
    transform: translate(-50%, 0)
    opacity: 0.8
    &::after
      content: ''
      position: absolute
      left: 50%
      bottom: -4px
      transform: translateX(-50%)
      border-left: 4px solid transparent
      border-right: 4px solid transparent
      border-top: 4px solid #3C4145
  .mapCenterDot
    @apply absolute
    left: 50%
    top: 0
    width: 10px
    height: 10px
    border-radius: 50%
    background: black
    border: 0.5px solid white
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25)
    transform: translate(-50%, -50%)
  .customPriceMarker
    @apply relative bg-white border border-grey-lighter font-bold text-grey-darker rounded-full text-sm
    padding: 7px
    &::before
      content: ''
      position: absolute
      left: 50%
      bottom: -5px
      transform: translateX(-50%)
      border-left: 5px solid transparent
      border-right: 5px solid transparent
      border-top: 5px solid #E6EAED
    &::after
      content: ''
      position: absolute
      left: 50%
      bottom: -4px
      transform: translateX(-50%)
      border-left: 4px solid transparent
      border-right: 4px solid transparent
      border-top: 4px solid white
    &.pattern-orange-dark
      h6
        @apply text-orange-dark
    &.pattern-blue-light
      h6
        @apply text-blue-light
    &.sold-out:not(.activate)
      @apply p-0
      width: 14px
      height: 14px
      background: #A3ABB2
      border: 0.5px solid white
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15)
      span
        display: none
      &::before, &::after
        content: none
    &.activate
      @apply shadow text-white bg-blue-light
      &::before
        border-top-color: #3AB3E2
      &::after
        border-top-color: #3AB3E2
      &.pattern-orange-dark
        @apply bg-orange-lightest text-orange-dark border-orange-dark
        border-width: 0.5px
        &::before
          border-top-color: #E07612
        &::after
          border-top-color: #FFF9EE
      &.pattern-blue-light
        @apply bg-blue-light border-blue-light
        border-width: 0.5px
        &::before
          border-top-color: #3AB3E2
        &::after
          border-top-color: #3AB3E2
      & + .infoWindow
        @apply block
      &.sold-out
        border-color: #A3ABB2
        background: #A3ABB2
        &::before
          border-top-color: #A3ABB2
        &::after
          border-top-color: #A3ABB2
  .infoWindow
    @apply hidden
    @apply shadow-lg overflow-hidden
    width: 360px
    position: absolute
    left: 50%
    transform: translate(-50%, 16px)
    border-radius: 20px
$blue: #078ABC
$blue2: #3AB3E2
$green: #709D00
$green2: #8FC112
$orange: #F7AC15
$orange2: #FFC349
.gmap::v-deep .vue-map .cluster
  @apply rounded-full font-mono
  &[style*="width: 40px"]
    // @apply bg-green-darker
    background-image: radial-gradient(circle, rgba($blue, 1) 40%, rgba($blue2, 0) 100%)
    z-index: 3
  &[style*="width: 41px"]
    // @apply bg-blue
    background-image: radial-gradient(circle, rgba($orange, 1) 40%, rgba($orange2, 0) 100%)
    z-index: 4
  &[style*="width: 42px"]
    // @apply bg-orange
    background-image: radial-gradient(circle, rgba($green, 1) 40%, rgba($green2, 0) 100%)
    z-index: 5
</style>
<style lang="sass">
.gm-style .gm-tilt
  display: none !important
gmp-internal-camera-control
  display: none !important
</style>
